// Calculate dosage for digestion formula
export function calculateDigestionDosage(answers) {
  // 山楂 (2-3g) - 针对油腻、肉食积滞
  let shanzha = 2;
  if (answers.dietHabits?.includes('greasy')) {
    if (answers.mainIssue?.includes('indigestion')) {
      shanzha = 3;
    } else {
      shanzha = 2.5;
    }
  } else if (answers.mainIssue?.includes('indigestion')) {
    shanzha = 2.5;
  }

  // 麦芽 (2-3g) - 针对米面积滞、腹胀
  let maiya = 2;
  if (answers.mainIssue?.includes('bloating')) {
    if (answers.bloatingTime === 'allday') {
      maiya = 3;
    } else if (answers.bloatingTime === '1-2hrs') {
      maiya = 2.5;
    } else {
      maiya = 2.5;
    }
  } else if (answers.mainIssue?.includes('poor_appetite')) {
    maiya = 2.5;
  }

  // 陈皮 (0.3-1g) - 针对气滞、嗳气、腹胀
  let chenpi = 0.3;
  const hasQiStagnation = answers.otherSymptoms?.includes('belching') || 
                          answers.mainIssue?.includes('bloating') ||
                          answers.otherSymptoms?.includes('acid_reflux');
  
  if (hasQiStagnation) {
    const qiStagnationCount = [
      answers.otherSymptoms?.includes('belching'),
      answers.mainIssue?.includes('bloating'),
      answers.otherSymptoms?.includes('acid_reflux')
    ].filter(Boolean).length;
    
    if (qiStagnationCount >= 2) {
      chenpi = 1;
    } else {
      chenpi = 0.7;
    }
  }

  // 计算总剂量等级
  const total = shanzha + maiya + chenpi;
  let level;
  if (total <= 5) level = 'light';
  else if (total <= 6) level = 'medium';
  else level = 'heavy';

  return {
    shanzha,
    maiya,
    chenpi,
    level,
    total
  };
}

// Determine review status
export function getDigestionReviewStatus(answers, dosage) {
  // Red flags
  if (answers.safety && !answers.safety.includes('none')) {
    return {
      status: 'red',
      label: 'Professional Review Required',
      message: 'Health risk factors detected, Professional practitioner review required.'
    };
  }

  if (answers.demographics?.age === 'other') {
    return {
      status: 'red',
      label: 'Professional Review Required',
      message: 'Age factors require confirmation by a professional practitioner'
    };
  }

  // Severe symptoms requiring review
  if (answers.otherSymptoms?.includes('pain') && answers.otherSymptoms?.includes('nausea')) {
    return {
      status: 'red',
      label: 'Professional Review Required',
      message: 'Abdominal pain with nausea/vomiting, professional assessment recommended.'
    };
  }

  // Yellow flags
  if (answers.duration === '>3months') {
    return {
      status: 'yellow',
      label: 'Priority Review',
      message: 'Chronic digestive issues, priority assessment recommended.'
    };
  }

  if (answers.otherSymptoms?.includes('acid_reflux')) {
    return {
      status: 'yellow',
      label: 'Priority Review',
      message: 'Acid reflux/heartburn symptoms, professional confirmation recommended.'
    };
  }

  if (answers.bowelMovement === 'alternating') {
    return {
      status: 'yellow',
      label: 'Priority Review',
      message: 'Alternating constipation and diarrhea, professional assessment recommended.'
    };
  }

  // Green
  return {
    status: 'green',
    label: 'Auto Approved',
    message: 'Formula generated, proceeding to production.'
  };
}

// Base formula
export const DIGESTION_BASE_FORMULA = [
  { name: 'Chinese yam', amount: '3.3g' },
  { name: 'Galli Gigerii Endothelium Corneum', amount: '2g' },
  { name: 'Amomum fruit', amount: '1g' },
  { name: 'Poria Mushroom', amount: '3g' },
  { name: 'Radish seed', amount: '2g' }
];